import React from 'react';
import { Translate } from 'react-redux-i18n';
import ScrollComponent from './../ScrollComponent';

const handleClickItem = (enableSearchByTicker, clickItemSearch, item) => () => {
  enableSearchByTicker ? clickItemSearch(item) : clickItemSearch(item.code);
};

export default function({
  parentListSearchRef,
  listSearchRef,
  currentItemActive,
  isShow,
  listFilter,
  enableSearchByTicker,
  clickItemSearch,
}) {
  return (
    <div
      className={`drop-search drop-mecus scroll-drop drop-10 ${
        isShow ? 'show' : ''
      }`}
    >
      <ScrollComponent
        appendStyle={{ maxHeight: 280 }}
        scrollRef={parentListSearchRef}
      >
        {listFilter.length === 0 ? (
          <a className="dropdown-item" href="#">
            <Translate value="common.NO_MATCHED_STOCK" />
          </a>
        ) : (
          listFilter.map((item, index) => {
            const { displayCode, codeName, exchange } = item;
            return (
              <a
                className={`dropdown-item ${
                  index === currentItemActive ? 'hover' : ''
                }`}
                href="#"
                key={displayCode}
                ref={el => (listSearchRef[index] = el)}
                onClick={handleClickItem(
                  enableSearchByTicker,
                  clickItemSearch,
                  item,
                )}
              >
                <span className="w-20">{displayCode}</span>
                <span className="w-55 text-truncate" title={codeName}>
                  {codeName}
                </span>
                <span className="w-25 text-right">
                  {exchange.toUpperCase()}
                </span>
              </a>
            );
          })
        )}
      </ScrollComponent>
    </div>
  );
}
